import React, { useContext, useEffect, useState } from 'react'
import CustomerTableHeading from '../CustomerTableHeading'
import CashZoneButton from '../CashZoneButton'
import PaginationButtons from '../PaginationButtons'
import LoginContext from '../../context'
import CustomerTableList from '../CustomerTableList'

const CustomerSection = () => {
    const { token } = useContext(LoginContext)
    const [inquiries, setInquiries] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;
    useEffect(() => {
        const fetchInqueries = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/inquiries/inquiries?page=${currentPage}&size=${pageSize}`, {
                    headers: {
                        'Accept': 'application/json',
                        Authorization: `Bearer ${token.token}`,
                    }
                });
                const data = await response.json();
                setInquiries(data.results);
                setTotalPages(data.total_pages);
                // console.log(data)
            } catch (error) {
                console.error('Error fetching notices:', error);
            }
        }
        fetchInqueries();
    }, [currentPage,]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    // console.log(inquiries)
    return (
        <>
            <CustomerTableHeading />
            <CustomerTableList inquiries={inquiries} />
            <div className='flex justify-center lg:justify-between items-center gap-1 px-2.5 py-5'>
                <CashZoneButton label="선택삭제" link_src="#" active_color="bg-amberGold" active={false} type="link" />
                <div className='flex justify-between gap-1'>
                    <CashZoneButton label="계좌문의" link_src="#" active_color="bg-[#cc001b]" active={true} type="link" />
                    <CashZoneButton label="글쓰기" link_src="/customer/write" active_color="bg-amberGold" active={true} type="link" />
                </div>
            </div>
            <div className='lg:py-2'>
                <PaginationButtons totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
            </div>
        </>
    )
}

export default CustomerSection